import { inject } from '@angular/core';
import { CanActivateFn, Router, type UrlTree } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { BillingApiService } from '../services/billing-api.service';

/** POSTPAID tenants are invoiced in arrears and do not purchase subscription plans. */
export function isPostpaidBillingType(billingType: string | null | undefined): boolean {
  return (billingType ?? '').toUpperCase() === 'POSTPAID';
}

/**
 * Blocks /subscriptions for POSTPAID tenants. PREPAID (and unknown on API failure) may proceed.
 */
export const prepaidBillingGuard: CanActivateFn = (): ReturnType<CanActivateFn> => {
  const billingApi = inject(BillingApiService);
  const router = inject(Router);

  return billingApi.summary().pipe(
    map((res): boolean | UrlTree => {
      if (isPostpaidBillingType(res?.data?.billing_type)) {
        return router.createUrlTree(['/dashboard']);
      }
      return true;
    }),
    catchError(() => of(true)),
  );
};
